import http from '@/http'

const authService = {
  /**
   * Login with email and password
   * Using Bearer token authentication (not session/CSRF)
   */
  async login(email, password) {
    return http.post('/admin/login', { email, password })
  },

  /**
   * Logout current user
   */
  async logout() {
    return http.post('/admin/logout')
  },

  /**
   * Get current authenticated user
   */
  async getCurrentUser() {
    return http.get('/admin/me')
  },

  /**
   * Send password reset link
   */
  async forgotPassword(email) {
    return http.post('/admin/forgot-password', { email })
  },

  /**
   * Reset password with token
   */
  async resetPassword(email, password, password_confirmation, token) {
    return http.post('/admin/reset-password', {
      email,
      password,
      password_confirmation,
      token,
    })
  },
}

export default authService
